<template>
	<div>
		<div class="content" ref="content">
			<div style="padding-left:40px;">
				<table class="table_t">
					<td class="topic">管理状态</td>
					<td>
						<span v-if="itemDetail.recordState == 0">待分配</span>
						<span v-else-if="itemDetail.recordState == 1">管理中</span>
						<span v-else-if="itemDetail.recordState == 2">管理结束</span>
						<span v-else-if="itemDetail.recordState == 4">勿访</span>
						<span v-else>已过期</span>
					</td>
					<td class="topic">管理总进度</td>
					<td>{{ (itemDetail.progress * 100 | 0) }}%</td>
				</table>
			</div>
			<el-timeline>
				<el-timeline-item>
					<div class="title">
						<p>入院初始 {{ (itemDetail.beginInHospital.progress * 100 | 0) }}%</p>
						<p v-if="itemDetail.recordState == 1||itemDetail.recordState == 2">
							<!-- <el-tag v-if="itemDetail.hospitalDetailPlusVo?.applicationStatus == 0" type="danger">未申请</el-tag> -->
							<el-tag v-if="itemDetail.hospitalDetailPlusVo?.applicationStatus == 1" effect='plain'
								type="success">已申请</el-tag>
							<el-tag v-else type="danger" effect='plain'>未申请</el-tag>

							<template v-if="itemDetail.recordState != 2">
								<el-button type="primary" size="small"
									v-if="itemDetail.hospitalDetailPlusVo?.applicationStatus != 1 && inEvalRules != 0"
									@click="openfirstDlg">申请开具六大处方</el-button>
								<el-button type="primary" size="small"
									v-if="itemDetail.hospitalDetailPlusVo?.applicationStatus == 1 && inEvalRules != 0"
									@click="openDlg">再次申请开具六大处方</el-button>
							</template>
						</p>
					</div>
					<table class="table_c">
						<thead>
							<td class="topic">模块</td>
							<td class="topic">完成状态</td>
							<td class="topic">操作时间</td>
							<td class="topic">推送时间</td>
							<td class="topic">操作人</td>
							<td class="topic">操作</td>
						</thead>
						<tbody>
							<tr>
								<td style="width: 25%;">入院评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[0]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag
										:type="evalLevelMap.inHospital.evalLevel[itemDetail.beginInHospital.evalResults[0]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[0]?.evalLevel">
										{{
											evalLevelMap.inHospital.evalLevel[itemDetail.beginInHospital.evalResults[0]?.evalLevel].label
										}}
									</el-tag>
									<el-tag
										:type="evalLevelMap.inHospital.evalLevel2[itemDetail.beginInHospital.evalResults[0]?.evalLevel2].type"
										v-if="itemDetail.beginInHospital.evalResults[0]?.evalLevel2">
										{{
											evalLevelMap.inHospital.evalLevel2[itemDetail.beginInHospital.evalResults[0]?.evalLevel2].label
										}}
									</el-tag>

								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[0]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[0]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[0]?.pushTime != null ? itemDetail.beginInHospital.evalResults[0]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[0]?.operater != null ?
										itemDetail.beginInHospital.evalResults[0]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[0])"
											:disabled="itemDetail.beginInHospital.evalResults[0]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i>
										</el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">饮食评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[1]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag
										:type="evalLevelMap.diet.evalLevel[itemDetail.beginInHospital.evalResults[1]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[1]?.evalLevel">
										{{
											evalLevelMap.diet.evalLevel[itemDetail.beginInHospital.evalResults[1]?.evalLevel].label
										}}
									</el-tag>
									<el-tag
										:type="evalLevelMap.diet.evalLevel2[itemDetail.beginInHospital.evalResults[1]?.evalLevel2].type"
										v-if="itemDetail.beginInHospital.evalResults[1]?.evalLevel2">
										{{
											evalLevelMap.diet.evalLevel2[itemDetail.beginInHospital.evalResults[1]?.evalLevel2].label
										}}
									</el-tag>

								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[1]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[1]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[1]?.pushTime != null ? itemDetail.beginInHospital.evalResults[1]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[1]?.operater != null ?
										itemDetail.beginInHospital.evalResults[1]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[1])"
											:disabled="itemDetail.beginInHospital.evalResults[1]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">运动评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[2]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag
										:type="evalLevelMap.sport[itemDetail.beginInHospital.evalResults[2]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[2]?.evalLevel">
										{{ evalLevelMap.sport[itemDetail.beginInHospital.evalResults[2]?.evalLevel].label }}
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[2]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[2]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[2]?.pushTime != null ? itemDetail.beginInHospital.evalResults[2]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[2]?.operater != null ?
										itemDetail.beginInHospital.evalResults[2]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[2])"
											:disabled="itemDetail.beginInHospital.evalResults[2]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">心理评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[3]?.status == 0" effect='plain'>
										未完成
									</el-tag>
									<el-tag
										:type="evalLevelMap.psychology[itemDetail.beginInHospital.evalResults[3]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[3]?.evalLevel">
										{{
											evalLevelMap.psychology[itemDetail.beginInHospital.evalResults[3]?.evalLevel].label
										}}
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[3]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[3]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[3]?.pushTime != null ? itemDetail.beginInHospital.evalResults[3]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[3]?.operater != null ?
										itemDetail.beginInHospital.evalResults[3]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[3])"
											:disabled="itemDetail.beginInHospital.evalResults[3]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">睡眠评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[5]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag
										:type="evalLevelMap.sleep[itemDetail.beginInHospital.evalResults[5]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[5]?.evalLevel">
										{{ evalLevelMap.sleep[itemDetail.beginInHospital.evalResults[5]?.evalLevel].label }}
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[5]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[5]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[5]?.pushTime != null ? itemDetail.beginInHospital.evalResults[5]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[5]?.operater != null ?
										itemDetail.beginInHospital.evalResults[5]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[5])"
											:disabled="itemDetail.beginInHospital.evalResults[5]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">中医评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[4]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag v-if="itemDetail.beginInHospital.evalResults[4]?.evalLevel == 0"
										type="success">平和</el-tag>
									<el-tag v-if="itemDetail.beginInHospital.evalResults[4]?.evalLevel > 0"
										type="danger">非平和</el-tag>

								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[4]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[4]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[4]?.pushTime != null ? itemDetail.beginInHospital.evalResults[4]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[4]?.operater != null ?
										itemDetail.beginInHospital.evalResults[4]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[4])"
											:disabled="itemDetail.beginInHospital.evalResults[4]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">入院疾病认知度</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[6]?.status == 0" effect='plain'>未完成</el-tag>
									<el-tag type="danger"
										v-if="itemDetail.beginInHospital.evalResults[6]?.score != null && itemDetail.beginInHospital.evalResults[6]?.score < 60">
										{{ itemDetail.beginInHospital.evalResults[6]?.score }}分
									</el-tag>
									<el-tag type="success" v-if="itemDetail.beginInHospital.evalResults[6]?.score >= 60">
										{{ itemDetail.beginInHospital.evalResults[6]?.score }}分
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[6]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[6]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[6]?.pushTime != null ? itemDetail.beginInHospital.evalResults[6]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[6]?.operater != null ?
										itemDetail.beginInHospital.evalResults[6]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[6])"
											:disabled="itemDetail.beginInHospital.evalResults[6]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">就医期望值评估</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[7]?.status == 0" effect='plain'>
										未完成</el-tag>
									<el-tag
										:type="evalLevelMap.expecte[itemDetail.beginInHospital.evalResults[7]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[7]?.evalLevel">
										{{ evalLevelMap.expecte[itemDetail.beginInHospital.evalResults[7]?.evalLevel].label
										}}
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[7]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[7]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[7]?.pushTime != null ? itemDetail.beginInHospital.evalResults[7]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[7]?.operater != null ?
										itemDetail.beginInHospital.evalResults[7]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											:disabled="itemDetail.beginInHospital.evalResults[7]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[7])">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">就医信心度</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.beginInHospital.evalResults[8]?.status == 0" effect='plain'>
										未完成</el-tag>
									<el-tag
										:type="evalLevelMap.confidence[itemDetail.beginInHospital.evalResults[8]?.evalLevel].type"
										v-if="itemDetail.beginInHospital.evalResults[8]?.evalLevel">
										{{
											evalLevelMap.confidence[itemDetail.beginInHospital.evalResults[8]?.evalLevel].label
										}}
									</el-tag>
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[8]?.finishTime != null ?
										itemDetail.beginInHospital.evalResults[8]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{itemDetail.beginInHospital.evalResults[8]?.pushTime != null ? itemDetail.beginInHospital.evalResults[8]?.pushTime:''}}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.beginInHospital.evalResults[8]?.operater != null ?
										itemDetail.beginInHospital.evalResults[8]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											:disabled="itemDetail.beginInHospital.evalResults[8]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)"
											@click="onEvalShowView(itemDetail.beginInHospital.evalResults[8])">
											<i class="icon-research" style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>

						</tbody>
					</table>
				</el-timeline-item>
				<el-timeline-item>
					<div class="title">
						<p>住院期间 {{ (itemDetail.duringInHospital.progress * 100 | 0) }}%</p>
						<p style="color: #F56C6C; flex:auto;margin-left: 12px;"
							v-if="itemDetail.hospitalDetailPlusVo?.againReason">{{
								itemDetail.hospitalDetailPlusVo.againReason}}</p>
						<p v-if="itemDetail.recordState == 1||itemDetail.recordState == 2">
							<!-- <el-tag v-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 0" type="danger">未创建</el-tag>
							<el-tag v-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 1" type="danger">待宣教</el-tag>
							<el-tag v-else-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 2" type="success">已宣教</el-tag> -->
							<!-- <el-tag v-else type="danger">待宣教</el-tag> -->
							<el-tag v-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 0 && itemDetail.hospitalDetailPlusVo?.publishStatus == 0" type="danger"  effect='plain'>未创建</el-tag>
							<el-tag v-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 0 && itemDetail.hospitalDetailPlusVo?.publishStatus == 1"  effect='plain'>待发布</el-tag>
							<el-tag v-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 1 && itemDetail.hospitalDetailPlusVo?.publishStatus == 2" type="danger" effect='plain'>待宣教</el-tag>
							<el-tag v-else-if="itemDetail.hospitalDetailPlusVo?.eduStatus == 2" type="success" effect='plain'>已宣教</el-tag>
							<template v-if="itemDetail.recordState != 2">
								<el-button type="primary" size="small"
									v-if="itemDetail.hospitalDetailPlusVo?.applicationStatus == 1 && inEvalRules != 0&&itemDetail.hospitalDetailPlusVo?.eduStatus != 0&&itemDetail.hospitalDetailPlusVo?.eduStatus != 2"
									@click="dlg.eduAct=true">宣教六大处方</el-button>
							</template>
						</p>
					</div>
					<table class="table_c table-tds">
						<thead>
							<td class="topic">模块</td>
							<td class="topic">完成状态</td>
							<td class="topic">操作时间</td>
							<td class="topic">推送时间</td>
							<td class="topic">操作人</td>
							<td class="topic">操作</td>
						</thead>
						<tbody>
							<tr>
								<td>饮食处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.diet?.status == 0" effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.diet?.status == 1" effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.diet?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.diet != null ?
										itemDetail.duringInHospital.diet.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.diet != null ?
										itemDetail.duringInHospital.diet.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.diet != null ?
										itemDetail.duringInHospital.diet?.operater : '' }}
								</td>
								<td>
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.diet != null && itemDetail.duringInHospital.diet?.status == 1"
											@click="openUserFollowup4(4)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>

									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.diet == null || itemDetail.duringInHospital.diet?.status != 1"
											@click="openUserFollowup4(4)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td>运动处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.sport?.status == 0" effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.sport?.status == 1" effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.sport?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.sport != null ?
										itemDetail.duringInHospital.sport.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.sport != null ?
										itemDetail.duringInHospital.sport.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.sport != null ?
										itemDetail.duringInHospital.sport?.operater : '' }}
								</td>
								<td>

									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.sport != null && itemDetail.duringInHospital.sport?.status == 1"
											@click="openUserFollowup4(5)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.sport == null || itemDetail.duringInHospital.sport?.status != 1"
											@click="openUserFollowup4(5)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td>心理处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.psy?.status == 0"  effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.psy?.status == 1"  effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.psy?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.psy != null ?
										itemDetail.duringInHospital.psy.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.psy != null ?
										itemDetail.duringInHospital.psy.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.psy != null ?
										itemDetail.duringInHospital.psy?.operater : '' }}
								</td>
								<td>

									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.psy != null && itemDetail.duringInHospital.psy?.status == 1"
											@click="openUserFollowup4(2)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.psy == null || itemDetail.duringInHospital.psy?.status != 1"
											@click="openUserFollowup4(2)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td>睡眠处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.sleep?.status == 0" effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.sleep?.status == 1" effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.sleep?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.sleep != null ?
										itemDetail.duringInHospital.sleep.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.sleep != null ?
										itemDetail.duringInHospital.sleep.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.sleep != null ?
										itemDetail.duringInHospital.sleep?.operater : '' }}
								</td>
								<td>

									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.sleep != null && itemDetail.duringInHospital.sleep?.status == 1"
											@click="openUserFollowup4(6)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.sleep == null || itemDetail.duringInHospital.sleep?.status != 1"
											@click="openUserFollowup4(6)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td>中医处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.tcm?.status == 0" effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.tcm?.status == 1" effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.tcm?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.tcm != null ?
										itemDetail.duringInHospital.tcm.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.tcm != null ?
										itemDetail.duringInHospital.tcm.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.tcm != null ?
										itemDetail.duringInHospital.tcm?.operater : '' }}
								</td>
								<td>

									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.tcm != null && itemDetail.duringInHospital.tcm?.status == 1"
											@click="openUserFollowup4(3)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.tcm == null || itemDetail.duringInHospital.tcm?.status != 1"
											@click="openUserFollowup4(3)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td>药物处方</td>
								<td>
									<el-tag v-if="itemDetail.duringInHospital.drug?.status == 0" effect='plain'>
										待发布
									</el-tag>
									<el-tag type="success" v-if="itemDetail.duringInHospital.drug?.status == 1" effect='plain'>
										已发布
									</el-tag>
									<el-tag type="info" v-if="itemDetail.duringInHospital.drug?.status == 2" effect='plain'>
										未评估
									</el-tag>
								</td>
								<td>
									{{ itemDetail.duringInHospital.drug != null ?
										itemDetail.duringInHospital.drug.operateTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.drug != null ?
										itemDetail.duringInHospital.drug.pushTime : '' }}
								</td>
								<td>
									{{ itemDetail.duringInHospital.drug != null ?
										itemDetail.duringInHospital.drug?.operater : '' }}
								</td>
								<td>

									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.drug != null && itemDetail.duringInHospital.drug?.status == 1"
											@click="openUserFollowup4(1)"><i class="icon-research"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											v-if="itemDetail.duringInHospital.drug == null || itemDetail.duringInHospital.drug?.status != 1"
											@click="openUserFollowup4(1)"><i class="icon-edit"
												style="font-size:20px"></i></el-button>
									</el-tooltip>
								</td>
							</tr>
						</tbody>
					</table>
				</el-timeline-item>
				<el-timeline-item>
					<div class="title">
						<p>出院前准备 {{ (itemDetail.prepOutHospital.progress * 100 | 0) }}%</p>

						<p v-if="itemDetail.recordState == 1||itemDetail.recordState == 2">
							<el-tag v-if="itemDetail.recordState == 2" type="success"  effect='plain'>已结束</el-tag>
							<el-tag v-else type="danger"  effect='plain'>未结束</el-tag>
							<template v-if='itemDetail.recordState!=2'>
								<el-button type="primary" size="small" v-if="itemDetail.recordState == 1 && inEvalRules != 0"
									@click="openFinishDlg">结束院中管理</el-button>
							</template>
						</p>
					</div>
					<table class="table_c">
						<thead>
							<td class="topic">模块</td>
							<td class="topic">完成状态</td>
							<td class="topic">操作时间</td>
							<td class="topic">操作人</td>
							<td class="topic">操作</td>
						</thead>
						<tbody>
							<tr>
								<td style="width: 25%;">出院疾病认知度</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.prepOutHospital.evals[0]?.status != 1" effect='plain'>
										未完成</el-tag>
									<el-tag type="danger"
										v-if="itemDetail.prepOutHospital.evals[0]?.score!=null && itemDetail.prepOutHospital.evals[0]?.score < 60">
										{{ itemDetail.prepOutHospital.evals[0]?.score }}分
									</el-tag>
									<el-tag type="success" v-if="itemDetail.prepOutHospital.evals[0]?.score >= 60">
										{{ itemDetail.prepOutHospital.evals[0]?.score }}分
									</el-tag>
								</td>
								<td style="width: 25%;">
									{{ itemDetail.prepOutHospital.evals[0]?.finishTime != null ?
										itemDetail.prepOutHospital.evals[0]?.finishTime : '' }}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.prepOutHospital.evals[0]?.operater != null ?
										itemDetail.prepOutHospital.evals[0]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text"
											:disabled="itemDetail.prepOutHospital.evals[0]?.status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)"
											@click="onEvalShowView(itemDetail.prepOutHospital.evals[0])">
											<i class="icon-research" style="font-size:20px"></i>
										</el-button>
									</el-tooltip>
								</td>
							</tr>
							<tr>
								<td style="width: 25%;">满意度调查</td>
								<td style="width: 15%;">
									<el-tag type="danger" v-show="itemDetail.prepOutHospital.questions[0]?.status != 1" effect='plain'>
										未完成</el-tag>
									<el-tag type="success" v-show="itemDetail.prepOutHospital.questions[0]?.status == 1" effect='plain'>
										已完成
									</el-tag>
								</td>
								<td style="width: 25%;">
									{{ itemDetail.prepOutHospital.questions[0].operateTime != null ?
										itemDetail.prepOutHospital.questions[0].operateTime : '' }}
								</td>
								<td style="width: 20%;">
									{{ itemDetail.prepOutHospital.questions[0]?.operater != null ?
										itemDetail.prepOutHospital.questions[0]?.operater : '' }}
								</td>
								<td style="width: 15%;">
									<el-tooltip class="item" effect="dark" content="查看" placement="top">
										<el-button type="text" v-if="itemDetail.prepOutHospital.questions[0].status == 1"
											:disabled="itemDetail.prepOutHospital.questions[0].status != 1 && ((itemDetail.recordState != 1 || itemDetail.recordState != 2) && inEvalRules == 0)"
											@click="openQue(itemDetail.prepOutHospital.questions[0].qcId, itemDetail.prepOutHospital.questions[0].id)">
											<i class="icon-research" style="font-size:20px"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip class="item" effect="dark" content="填写" placement="top">
										<el-button type="text"
											:disabled="itemDetail.prepOutHospital.questions[0].status != 1 && inEvalRules == 0"
											v-if="itemDetail.prepOutHospital.questions[0].status != 1"
											@click="addQue(itemDetail.prepOutHospital.questions[0].qcId)"><i
												class="icon-edit" style="font-size:20px"></i></el-button>
									</el-tooltip>
									<el-popconfirm confirmButtonText='删除' title="确定删除吗？"
										@confirm="delQuest(itemDetail.prepOutHospital.questions[0].id)">
										<el-tooltip slot="reference" class="item" effect="dark" content="删除"
											placement="top">
											<el-button type="text"
												:disabled="itemDetail.prepOutHospital.questions[0]?.status != 1">
												<i class="el-icon-delete" style="font-size:20px;margin-left:10px;"></i>
											</el-button>
										</el-tooltip>
									</el-popconfirm>
								</td>
							</tr>

						</tbody>
					</table>
				</el-timeline-item>
			</el-timeline>

			<!-- <el-row style="text-align: center;" v-show="itemDetail.recordState != 5">
				<el-popover placement="bottom" width="160" v-model="visible">
					<p>确定结束院中管理么？</p>
					<div style="text-align: right; margin: 0">
						<el-button size="mini" type="text" @click="visible = false">取消</el-button>
						<el-button type="primary" size="mini" @click="visible = false">确定</el-button>
					</div>
					<el-button slot="reference" type="danger">结束院中管理</el-button>
				</el-popover>
			</el-row> -->

		</div>
		<el-dialog title="重新申请开具六大处方" width="600px" :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form" class="dlgForm">
				<el-form-item label="重新申请的处方" prop="evalTypeId">
					<el-checkbox-group v-model="form.evalTypeId">
						<el-checkbox :label="6">饮食处方</el-checkbox>
						<el-checkbox :label="5">运动处方</el-checkbox>
						<el-checkbox :label="2">心理处方</el-checkbox>
						<el-checkbox :label="7">睡眠处方</el-checkbox>
						<el-checkbox :label="3">中医处方</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="重新申请的原因" prop="againReason">
					<el-radio-group v-model="form.againReason">
						<el-radio label="评估填写有误">评估填写有误</el-radio>

						<el-radio label="other">其他原因</el-radio>
						<el-input v-if="form.againReason == 'other'" size="mini" placeholder="输入其他原因" style="width: 250px;"
							v-model="form.otherReason" maxlength="25"></el-input>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">关 闭</el-button>
				<el-button type="primary" :loading="isLoading" @click="saveForm">保 存</el-button>
			</div>
		</el-dialog>
		<el-dialog title="申请开具六大处方" width="600px" :visible.sync="dlg.firstAct" :close-on-click-modal="false">
			<p>还有{{ noEval.length }}个模块尚未完成:
				<span v-for="(item, index) in noEval" :key="index" style="color:#F56C6C">{{ item.evalName }}、</span>
			</p>
			<p>确定通知医生开具六大处方?</p>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" :loading="isLoading" @click="savefirstForm">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="系统提示" width="600px" :visible.sync="dlg.finishAct" :close-on-click-modal="false">
			<p>是否结束院中管理?</p>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" :loading="isLoading" @click="finishHandle">确定</el-button>
			</div>
		</el-dialog>
		<el-dialog title="六大处方宣教" width="600px" :visible.sync="dlg.eduAct" :close-on-click-modal="false">
			<p><span style="color:#F56C6C">*</span>确认六大处方宣教成功,</p>
			<p>六大处方中内容已向患者详细说明。</p>
			<div slot="footer" class="dialog-footer">
				<el-button :loading="isLoading" @click="closeDlg">取消</el-button>
				<el-button type="primary" :loading="isLoading" @click="eduHandle">确定</el-button>
			</div>
		</el-dialog>
		<!-- 右侧评估列表弹窗 -->
		<EvalList :type="evalList.type" :name="evalList.name" :patientId="patientId" :customerId="customerId"
			:visible.sync="evalList.active" :detailVisible.sync="evalList.detailActive" :evalId="evalList.evalId" />
		<!-- y右侧评估结果弹窗 -->
		<EvalDetail :name="evalList.name" :customerId="customerId" :id="evalDetail.id" :type="evalList.type"
			:detailVisible.sync="evalDetail.active" @viewHistory="onEvalShowViewList" />
		<!-- <EvalDetail :name="name" :customerId="customerId" :id="evalId" :type="type" :visible.sync="detailVisible" @reload="loadList" /> -->
	</div>
</template>

<script>
import api from '@/service/api.js';
import EvalList from './special/components/eval-list.vue';
import EvalDetail from './special/components/eval-detail.vue';
import { EventBus } from '@/event-bus.js';

export default {
	props: {
		patientId: {
			required: true
		},
		onEvalShow: {
			type: Function,
			default: null
		},
		recordId: {
			required: true
		},
		customerId: {
			required: true
		},
		datasources: {
			required: true
		},
	},
	components: {
		// Diet,
		// Drug,
		// Medicine,
		// Psychology,
		// Sleep,
		// Sports,
		EvalList,
		EvalDetail
	},
	data() {
		return {
			visible: false,
			flag: false,
			prescriptionActive: {
				type: 0,
				visible: false
			},
			permission: false,
			evalList: {
				active: false,
				detailActive: false,
				type: 0
			},
			prescriptionItem: {},
			itemDetail: {
				beginInHospital: {
					progress: 0,
					evalResults: [{
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}]
				},
				duringInHospital: {
					progress: 0,
					diet: {
						operateTime: null,
						operater: null,
						status: null
					},
					drug: {
						operateTime: null,
						operater: null,
						status: null
					},
					psy: {
						operateTime: null,
						operater: null,
						status: null
					},
					sleep: {
						operateTime: null,
						operater: null,
						status: null
					},
					sport: {
						operateTime: null,
						operater: null,
						status: null
					},
					tcm: {
						operateTime: null,
						operater: null,
						status: null
					}
				},
				prepOutHospital: {
					progress: 0,
					evals: [{
						status: 0
					}, {
						status: 0
					}, {
						status: 0
					}],
					questions: [{
						status: 0
					}]
				}
			},
			evalDetail: {
				active: false,
				id: 0,
			},
			evalDetail8: {},
			inEvalRules: null,
			dlg: {
				active: false,
				firstAct: false,
				finishAct: false,
				eduAct:false,
				rules: {
					evalTypeId: { required: true, message: '请选择' },
					againReason: { required: true, message: '请选择' },
				}
			},
			form: {
				evalTypeId: [],
				evalTypeIds: null,
				againReason: null
			},
			evalLevelMap: {
				// 运动评估5
				sport: {
					1: { label: '低风险', type: 'success' },
					2: { label: '中风险', type: 'warning' },
					3: { label: '高风险', type: 'danger' }
				},

				// 心理评估2
				psychology: {
					1: { label: '正常', type: 'success' },
					2: { label: '异常', type: 'danger' },
					3: { label: '异常', type: 'danger' }
				},
				// 入院评估4
				inHospital: {
					evalLevel: {
						1: { label: '体重过低', type: '' },
						2: { label: '体重正常', type: 'success' },
						3: { label: '超重', type: 'warning' },
						4: { label: '肥胖', type: 'danger' }
					},
					evalLevel2: {
						1: { label: '血压偏低', type: '' },
						2: { label: '正常血压', type: 'success' },
						3: { label: '正常高值血压', type: 'success' },
						4: { label: '一级高血压', type: 'warning' },
						5: { label: '二级高血压', type: 'danger' }
					}
				},
				// 饮食评估6
				diet: {
					evalLevel: {
						1: { label: '不足', type: '' },
						2: { label: '合理', type: 'success' },
						3: { label: '超标', type: 'danger' }
					},
					evalLevel2: {
						1: { label: '较均衡', type: 'success' },
						2: { label: '轻度不均衡', type: 'warning' },
						3: { label: '明显不均衡', type: 'danger' }
					}
				},

				// 睡眠评估7
				sleep: {
					1: { label: '低风险', type: 'success' },
					2: { label: '高风险', type: 'danger' }
				},
				confidence: {
					1: { label: '正常', type: 'success' },
					2: { label: '偏低', type: 'warning' },
					3: { label: '过低', type: 'danger' }
				},
				expecte: {
					1: { label: '正常', type: 'success' },
					2: { label: '偏高', type: 'warning' },
					3: { label: '过高', type: 'danger' }
				},

			},
			my: undefined,
			noEval: [],
			
		}
	},
	created() {
		this.init();
	},
	mounted() {
		let query = this.$route.query;
		document.addEventListener('visibilitychange', this.handleVisiable)

		EventBus.$on('update-eval-data', (newVal) => {
			console.log(newVal);
			this.loadDetail();
		});
	},
	destroyed() {
		document.removeEventListener('visibilitychange', this.handleVisiable);
	},
	methods: {
		handleVisiable(e) {
			// 关闭新开页面，回到列表页，刷新列表数据
			if (e.target.visibilityState == "visible") {
				this.loadDetail();
			}
		},
		async init() {
			await this.loadDetail();
			let res = await api.getSysRule();
			if (res.code == 500) { return this.$router.push({ name: 'Login', query: { r: location.href } }); }
			this.inEvalRules = res.data.in_eval.enable;
			// await this.loadPrescription();
			// let res = await api.getCustomerAllEval({customerId: this.customerId,type:1});
			// this.getSideEvalList = res.data;
		},
		async loadDetail() {
			if (this.recordId != "") {
				this.isLoading = true;
				let res = await api.getInhospitalInfo(this.recordId);
				if (res.code != 1000) {
					return this.$message.error(res.message);
				}
				this.itemDetail = res.data;
				this.itemDetail.prepOutHospital.evals.push({
					status: 0
				});
				this.itemDetail.prepOutHospital.evals.push({
					status: 0
				})
				this.evalDetail8 = JSON.parse(res.data.beginInHospital.evalResults[8].evalResult)
				this.isLoading = false;

			}
		},
		openUserFollowup4(t) {
			this.$emit("openUserFollowup4", t);
		},
		onEvalShowViewList() {
			this.evalList.active = true;
		},
		onEvalShowView(item) {
			this.evalList.type = +item.type || +item.evalTypeId;
			this.evalList.name = item.evalName;
			this.evalDetail.id = item.evalId;
			if (item?.status == 0) {
				this.onEvalShowViewList()
			} else {
				this.evalDetail.active = true;
			}
		},
		openDlg() {
			this.dlg.active = true;

		},
		openfirstDlg() {
			this.noEval = this.itemDetail.beginInHospital.evalResults.filter(item => item.type !== "8" && item.type !== "9" && item.type !== "12" && item.status === 0);
			this.dlg.firstAct = true;
		},
		async savefirstForm() {
			// let evalId = this.itemDetail.beginInHospital.evalResults.filter(item => item.status === 1).map(item => item.type);
			// if (evalId.length > 0) {
			// 	this.form.evalTypeIds = evalId.join(',')
			// }
			this.form.evalTypeIds =null;
			this.form.customerId = this.customerId;
			this.form.inHospitalId = this.itemDetail.id;
			this.form.againReason=null

			let res = await api.applyPrescription(this.form);
			if (res.code != 1000) {
				this.$message.error(res.message);
				return;
			}
			this.$message({ message: '申请成功', type: 'success' });
			this.closeDlg();
			this.init();
		},
		async saveForm() {
			this.$refs['form'].validate(async (valid) => {
				if (valid) {
					if (this.form.evalTypeId.length > 0) {
						this.form.evalTypeIds = this.form.evalTypeId.join(',')
					}

					if(this.form.againReason == 'other'){
						this.form.againReason =this.form.otherReason
					}
					console.log(this.form);
					this.form.customerId = this.customerId;
					this.form.inHospitalId = this.itemDetail.id;
					let res = await api.applyPrescription(this.form);
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.$message({ message: '申请成功', type: 'success' });
					this.closeDlg();
					this.init();
				}
			})
		},
		closeDlg() {
			this.dlg.active = false;
			this.dlg.firstAct=false;
			this.dlg.finishAct=false;
			this.dlg.eduAct=false;
			console.log(this.dlg.eduAct);
		},
		async eduHandle() {
			let res = await api.eduPrescription({ inHospitalId: this.itemDetail.id });
			if (res.code != 1000) {
				this.$message.error(res.message);
				return;
			}
			this.closeDlg();
			this.loadDetail();

			this.$message({ message: '宣教成功', type: 'success' });
		},
		openFinishDlg(){
			this.dlg.finishAct=true;
		},
		async finishHandle() {
			let res = await api.finishInhospital({ id: this.itemDetail.id });
			if (res.code != 1000) {
				this.$message.error(res.message);
				return;
			}
			this.dlg.finishAct=false;
			this.$message({ message: '院中管理已结束', type: 'success' });
			this.init();

		},
		openQue(qcId, id) {
			const href = this.$router.resolve({
				path: '/qst/' + qcId,
				query: {
					rid: id,
					t: JSON.parse(localStorage.getItem('user')).data.token,
				}
			})
			let openWin = window.open(href.href, "_blank");

		},
		// 填写满意度问卷
		async addQue(id) {
			this.my = JSON.parse(localStorage.getItem('user')).data;
			let opt = {
				"customerId": this.customerId || 0,
				"patientId": this.patientId,
				"qcId": id,
				"recordId": this.itemDetail.id,
				"recordType": 1
			}
			let res1 = await api.questionresultAdd(opt);
			if (res1.code == 1000) {
				// let data1 = res1.data;
				// let questionnaireJson = JSON.parse(res.data.questionnaireJson);
				const href = this.$router.resolve({
					path: '/qst/' + res1.data.qcId,
					query: {
						rid: res1.data.id,
						t: this.my.token,
					}
				})
				window.open(href.href, "_blank");
			} else {
				this.$message.info(res1.message);
			}
			this.$emit('update:writeQuestionnaire', true)
		},
		async delQuest(id) {
			let res = await api.delQuestionnaireResult(id);
			if (res.code == 1000) {
				this.init();
			}
		},
	}
}
</script>

<style lang="less" scoped>
.content {
	padding: 50px;
	border-top: 1px solid #eee;
	background-color: #ffffff;
	overflow-x: auto;

	::v-deep .el-timeline {
		margin-top: 36px;
		.el-timeline-item__wrapper {
			padding-top: 10px;
		}
	}
}

.table_t {
	border: 1px solid #4D4D4D;
	border-collapse: collapse;
	border-spacing: 0;
	text-align: center;
	font-size: 18px;
	color: #333333;
	width: 100%;
	margin-bottom: 20px;
}

.table_t th {
	height: 80px;
	border: 1px solid #4D4D4D;
}

.table_t td {
	height: 80px;
	line-height: 80px;
	border: 1px solid #4D4D4D;
	width: 25%;
}

.topic {
	background-color: #EBF4FF;
}

.table_c {
	border-collapse: collapse;
	border-spacing: 0;
	font-size: 18px;
	width: 100%;
	color: #616161;
}

.table_c td {
	padding-left: 18px;
	height: 50px;
	width: 20%;
	border-bottom: 1px solid #EBF4FF;

	::v-deep .el-tag {
		margin-right: 4px;
	}
}

.table-tds {
	td {
		width: 16% !important;

	}

	thead {
		td:first-child {
			width: 25% !important;
		}
	}

	tr {
		td:first-child {
			width: 15% !important;
		}
	}
}

.title {
	font-size: 16px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: -15px;

	p {
		margin: 0;

		::v-deep .el-tag {
			margin-right: 12px;
		}
	}
}

.gray {
	color: #858585;
}

.tips_c {
	background-color: #ffffff;
	text-align: center;
}

.dlgForm {
	::v-deep .el-form-item {
		.el-form-item__label {
			width: 100% !important;
			text-align: left;
		}
	}

	::v-deep .el-form-item__content {
		margin-left: 0 !important;

		.el-radio {
			margin-right: 16px;

			.el-radio__label {
				padding-left: 6px;
			}
		}
	}
}</style>
